import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function FinalCTA() {
  const {
    formatted,
    isUrgent
  } = useCountdown(14, 8);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="final-cta" className="py-16 md:py-20 px-4 bg-dark relative overflow-hidden" data-id="element-32">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber/5 rounded-full blur-[150px] pointer-events-none" data-id="element-33"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-34">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-35">
          <h2 className="font-heading text-4xl sm:text-5xl md:text-7xl font-black text-ivory mb-6 md:mb-8 uppercase tracking-tight" data-id="element-36">
            Ready to Master the Flame?
          </h2>

          {/* Timer Box */}
          <div className="inline-flex items-center gap-2 md:gap-3 bg-dark-contrast border border-amber/40 rounded-lg px-4 py-2 md:px-6 md:py-3 mb-8 md:mb-12" data-id="element-37">
            <span className="text-smoke text-sm md:text-base font-medium" data-id="element-38">
              Offer expires in:
            </span>
            <motion.span animate={isUrgent ? {
            color: ['#E69D4F', '#FFD700', '#E69D4F']
          } : {}} transition={{
            duration: 1,
            repeat: Infinity
          }} className="font-mono text-amber text-lg md:text-2xl font-bold tracking-widest" data-id="element-39">
              {formatted}
            </motion.span>
          </div>

          <div className="mb-8 md:mb-10" data-id="element-40">
            <a href="https://www.vitalyforms.com/cart/50069069365468:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="w-full sm:w-auto inline-block text-center bg-gradient-to-r from-[#F2B851] to-[#C45F2A] border-b-4 border-[#964215] rounded-md text-[#0F1111] font-black uppercase text-base sm:text-xl md:text-2xl py-4 md:py-6 px-6 md:px-16 shadow-[0_0_30px_rgba(242,184,81,0.5)] hover:brightness-110 hover:-translate-y-0.5 active:translate-y-0.5 active:border-b-2 transition-all duration-200" data-id="element-41">
              🔥 GET THE PITMASTER SYSTEM — $6.36 →
            </a>
            <p className="text-smoke text-sm mt-3 flex items-center justify-center gap-1.5" data-id="element-42">
              ⚡ Instant digital delivery — sent straight to your inbox
            </p>
          </div>

          <div className="flex flex-col items-center justify-center gap-2 md:gap-3" data-id="element-43">
            <div className="flex gap-1" data-id="element-44">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 md:w-6 md:h-6 fill-gold text-gold" data-id="element-45" />)}
            </div>
            <p className="text-smoke font-medium text-base md:text-lg" data-id="element-46">
              Join 2,847+ backyard pitmasters who made the switch
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}